export const initialise = () => {
    const page = document.querySelector<HTMLBodyElement>('.page-jobs')
    if (!page) return
    removeHeader(page)
    addFiltersButtons(page)
    filters(page)
    moveKeyword(page)
    enableSearchOnEnter();
}

const removeHeader = (page: HTMLBodyElement) => {
    const header = page.querySelector<HTMLDivElement>('#filter-header')
    header?.remove()
}

const addFiltersButtons = (page: HTMLBodyElement) => {
    const container = page.querySelector<HTMLElement>('.page-jobs__container-filters .container-col')
    if (!container) return

    const group: HTMLDivElement = document.createElement('div')
    group.classList.add('page-jobs__container-filters-buttons')
    
    const apply: HTMLButtonElement = document.createElement('button')
    apply.classList.add('page-jobs__container-filters-button-apply')
    apply.innerText = '{{js.job-results.filters.button.apply.content}}'
    apply.ariaLabel = '{{js.job-results.filters.button.apply.aria-label}}'
    apply.addEventListener('click', () => {
        (window as any).jobFilterNoReloadController.applyJobFilters()
    })

    const clear: HTMLAnchorElement = document.createElement('a')
    clear.classList.add('page-jobs__container-filters-button-clear')
    clear.innerText = '{{js.job-results.filters.button.clear.content}}'
    clear.ariaLabel = '{{js.job-results.filters.button.clear.aria-label}}'
    clear.href = '{{js.job-results.filters.button.clear.link}}'

    group.appendChild(apply)
    group.appendChild(clear)
    container.appendChild(group)
}

const filters = (page: HTMLBodyElement) => {
    const filters: NodeListOf<HTMLDivElement> = page.querySelectorAll('.optionfiltergroup')

    filters.forEach((filter: HTMLDivElement) => {
        const button = filter.querySelector<HTMLHeadingElement>('.option-type-header-text')
        if (!button) return

        button.addEventListener('click', function(event: Event) {
            document.addEventListener('click', function clickAway(event: Event) {
                const target: HTMLElement = event.target as HTMLElement
                if (!filter.contains(target)) { 
                    button.setAttribute('aria-expanded', 'false')
                    filter.classList.remove('category-opened')
                    document.removeEventListener('click', clickAway)
                }
            })

            filter.addEventListener('focusout', function tabAway(event: FocusEvent) {
                const target: HTMLElement = event.relatedTarget as HTMLElement
                if (!filter.contains(target)) {
                    button.setAttribute('aria-expanded', 'false')
                    filter.classList.remove('category-opened')
                    filter.removeEventListener('focusout', tabAway)
                }
            })
            
            const openedFilters: NodeListOf<HTMLDivElement> = page.querySelectorAll('.category-opened')
            if (filter.classList.contains('category-opened')) {
                filter.classList.remove('category-opened')
            } else {
                openedFilters.forEach((filter: HTMLDivElement) => {
                    filter.classList.remove('category-opened')
                })
                filter.classList.toggle('category-opened')
            }

            const isExpanded: boolean = filter.classList.contains('category-opened')
            button.setAttribute('aria-expanded', isExpanded.toString())
        })
    })
}

const moveKeyword = (page: HTMLBodyElement) => {
    const keywordElement = page.querySelector<HTMLElement>('#keyword-option-wrapper')
    if (!keywordElement) return

    const container = document.querySelector<HTMLDivElement>('.page-jobs__container-filters .container-col')
    container?.append(keywordElement)
}


const enableSearchOnEnter = () => {
  const searchInput = document.querySelector<HTMLInputElement>(".search-filters-widget__filter-search-input")
    if (!searchInput) return

    searchInput.addEventListener("keydown", (event: KeyboardEvent) => {
        if (event.key === "Enter") {
            event.preventDefault()
            const parentElement = searchInput.closest<HTMLDivElement>(".search-filters-widget__filter-search")
            const searchButton = parentElement?.querySelector<HTMLButtonElement>(".search-filters-widget__filter-search-btn")
            searchButton?.click()
        }
    })
}